const sendMessageToBot = async (data: any) => {
    try {
        const response = await fetch('http://13.233.2.133:5003/public', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response.json();
    } catch (error) {
        console.error('Error:', error);
    }
}

export default sendMessageToBot;